const RequestManager = {
  endPoint: `https://apidev.daftareshoma.com`,
  apiCoreEndPoint: 'https://coreapi.dev.daftareshoma.com',

  varsion: ``,
  prefix: ``,
  controllers: {
    Auth: {
      name: '',
      actions: {
        Login: {
          name: 'Login',
          path: '/token',
          method: 'post',
          enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: "با موفقیت وارد شدید"
        },


      },
    },
    OaaLogin: {
      name: "api/OaaLogin",
      actions: {
        GetUrlToLogin: {
          name: "GetUrlToLogin",
          path: "/GetUrlToLogin",
          method: "get",
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    Instruction: {
      name: 'api/Instruction',
      actions: {
        GetInstruction: {
          name: 'GetInstruction',
          path: '/Get',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      }

    },
    OaaIdentity: {
      name: 'api/OaaIdentity',
      actions: {
        GetIdentityInfo: {
          name: 'GetIdentityInfo',
          path: '/GetIdentityInfo',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      }

    },
    OaaCustomers: {
      name: 'api/OaaCustomers',
      actions: {
        GetActiveCustomers: {
          name: 'GetActiveCustomers2',
          path: '/GetActiveCustomers2',
          method: 'post',
          enable_message: false,

          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetLineSecrateryForCustomers: {
          name: 'GetLineSecrateryForCustomers',
          path: '/GetLineSecrateryForCustomers',
          method: 'post',
          enable_message: false,

          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      }

    },
    Customers: {
      name: 'api/Customer',
      actions: {

        GetLineSecrateryForCustomers: {
          name: 'GetLineSecrateryForCustomers',
          path: '/GetLineSecrateryForCustomers',
          method: 'post',
          enable_message: false,

          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      }

    },
    CustomerAttachment: {
      name: 'api/CustomerAttachment',
      actions: {
        getCustomerAttachmentById: {
          name: 'getCustomerAttachmentById',
          path: '/getCustomerAttachmentById',
          method: 'post',
          enable_message: false,

          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      }

    },
    CallReport: {
      name: 'api/CallReport',
      actions: {
        Save: {
          name: 'Save',
          path: '/Save',
          method: 'post',
          enable_message: true,
          successMessage: "عملیات ثبت با موفقیت انجام شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Edit: {
          name: 'Edit',
          path: '/Edit',
          method: 'post',
          enable_message: true,
          successMessage: "عملیات ویرایش با موفقیت انجام شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      }

    },
    CustomerLine: {
      name: 'api/CustomerLine',
      actions: {
        CallHistoryByLineNumber: {
          name: 'CallHistoryByLineNumber',
          // path: '/GetCallAnswering_CallHistory_ByLineNumber',
          path: '/GetCallAnswering_CallHistory_ByLineNumber2',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        CallHistoryByAcdExtension: {
          name: 'CallHistoryByAcdExtension',
          path: '/GetCallAnswering_CallHistory_ByAcdExtension',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCallAnsweringInstructionByLineNumber: {
          name: 'GetCallAnsweringInstructionByLineNumber',
          path: '/GetCallAnswering_Instruction_ByLineNumber',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCallAnsweringCustomerInfoByLineNumber: {
          name: 'GetCallAnsweringCustomerInfoByLineNumber',
          path: '/GetCallAnswering_CustomerInfo_ByLineNumber',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetCallAnswering_Instruction_ByCallReportId: {
          name: 'GetCallAnswering_Instruction_ByCallReportId2/',
          path: '/GetCallAnswering_Instruction_ByCallReportId2',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },


    },
    Operator: {
      name: 'api/Operator',
      actions: {
        SetOperatorOnline: {
          name: 'SetOperatorOnline',
          path: '/SetOperatorOnline',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SetOperatorOffline: {
          name: 'SetOperatorOffline',
          path: '/SetOperatorOffline',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetAlloperator: {
          name: 'GetAlloperator',
          path: '/GetAlloperator',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      }

    },
  }
}

export default RequestManager;


export const getRequestRequirement = (path) => {
  let resPath = '';
  let action = {};
  const splitedPath = path.split('.')
  const controller = RequestManager.controllers;
  if (controller[splitedPath[0]]) {
    resPath = controller[splitedPath[0]].name
    const actions = controller[splitedPath[0]].actions;
    if (actions[splitedPath[1]]) {
      action = actions[splitedPath[1]];
      resPath += actions[splitedPath[1]].path
    }
  }
  return { path: resPath, action };
}
